import Plyr from 'plyr';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
//import { ScrollTrigger } from 'gsap/ScrollTrigger';
//gsap.registerPlugin( ScrollTrigger);

// Vimeo Player SDK:  https://developer.vimeo.com/player/sdk
const console = window.console;

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,
        	trackGAEvents: true,

        	scrollaAutopause: false,
        	debug: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'plyr_playlist';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$window 		= 	$(window);

		this.init( true );
    }

    init( b ){
    	this.initPlayers( b );

    	if ( b ){
			this.$el.addClass( 'ready' );    		
    	}
	}

	initPlayers( b ){
		if ( b ){
			this.index 		= 0;
			this.players 	= [];
			this.navs    	= [];

			this.$el.find( '.video-container' ).each( (i,el)=>{

				let o = {
					$container: $(el),
					is_plyr: $(el).find( '.is-plyr' ).length > 0,
					$player: $(el).find( '.video-embed-player' ),
					resized: false
				}

				this.players[i] = o;
			});

			this.$el.find( '.sidebar nav a' ).each( (i,el) =>{
				$(el).on( 'click', (e)=>this.onClickNav(e) );
				this.navs[i] = $(el);
			});

		}
		else{
		}

		this.debounceResize( b );
	}


	onClickNav(e){
		e.preventDefault();
		let $el = $(e.currentTarget), index = parseInt( $el.attr('data-index') );

		if ( index !== this.index ){
			this.selectPlayListIndex( index );	
		}
	}

	selectPlayListIndex( index ){
		let $p, c;
		this.navs[ 		this.index ].removeClass( 'current' );
		this.players[ 	this.index ].$container.removeClass( 'current' );

		// stop player !!!
		if( this.players[ 	this.index ].is_plyr ){
			$p = this.players[ 	this.index ].$player;
			if ( $p.length > 0 ){
				if ( $p.data( 'widget' ) ){
					// $p.data( 'widget' ).play( false ); // this is to STOP and so returning to the beginning
					$p.data( 'widget' ).pause();
				}
			}
			 
		}


		this.index 	= index;
		this.navs[ 		this.index ].addClass( 'current' );
		this.players[ 	this.index ].$container.addClass( 'current' );

		if ( !this.players[ this.index ].resized ){
			this.players[ this.index ].resized = true;
			$p 			= this.players[ 	this.index ].$player;
			c 			= $p.data( 'widget' );
			if ( c ){
				if ( c.resizeToItsRatio ){
					c.resizeToItsRatio()
				}
			}
		}

	}

	
    debounceResize( b ){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 77 );
			this.$window.on( 'resize', this._debResize );

			this.onResize()
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$window.off( 'resize', this._debResize );
			}        
		}
    }


    onResize(){
    	return;


    	let $l = this.$el.find( '.layout' ), w = $l.find('.players').width(), $s;
    	$l.height( w*3/4 );
    	$s = $l.find( '.scroll-ui' );
    	$s.height( $l.height() - $l.find('h4').outerHeight() );
    }
    

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.init( false );
    }

}


